import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Session from '../services/session';

/**
 * Link-account route — handles bot account linking.
 * Requires authentication; the token is read from query params in the template.
 */
export default class LinkAccountRoute extends Route {
  @service declare session: Session;
  @service declare router: RouterService;

  queryParams = { token: { refreshModel: false } };

  beforeModel() {
    if (!this.session.isAuthenticated) {
      this.router.transitionTo('login');
    }
  }
}
